import React from 'react';

type PktAlertSkin = 'info' | 'success' | 'warning' | 'error';

interface PktAlertProps {
  title: string;
  skin: PktAlertSkin;
  compact?: boolean;
  children?: React.ReactNode;
}

const SKIN_STYLES: Record<PktAlertSkin, { bg: string; border: string; icon: string }> = {
  info:    { bg: '#e6f0fa', border: '#1a7ec1', icon: 'i' },
  success: { bg: '#e6f4e6', border: '#287233', icon: '✓' },
  warning: { bg: '#fff4cc', border: '#f0c419', icon: '!' },
  error:   { bg: '#fbe6e6', border: '#b3261e', icon: '!' },
};

const PktAlert: React.FC<PktAlertProps> = ({ title, skin, compact, children }) => {
  const colors = SKIN_STYLES[skin];
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        gap: '0.75rem',
        alignItems: 'flex-start',
        background: colors.bg,
        borderLeft: `4px solid ${colors.border}`,
        padding: compact ? '0.5rem 0.75rem' : '1rem 1.25rem',
        borderRadius: 2,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          flex: '0 0 auto',
          width: '1.5rem',
          height: '1.5rem',
          borderRadius: '50%',
          background: colors.border,
          color: '#000',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.9rem',
          lineHeight: 1,
        }}
      >
        {colors.icon}
      </span>
      <div style={{ flex: '1 1 auto' }}>
        <div style={{ fontWeight: 700, marginBottom: compact ? 0 : '0.25rem' }}>{title}</div>
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};

export default PktAlert;
